<template>
	<my-dialog ref="selectCustomer" :visible.sync="showDialog" title="选择顾客" dialog-type="form" :close-on-click-modal="false" width="80%" append-to-body @close="closeDialog">
		<div>
			<el-form :inline="true" :model="formInline" class="user-search" style="margin-top: -10px">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="顾客姓名：">
					<el-input clearable v-model="formInline.name" size="small" placeholder="请输入顾客姓名" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="电话：">
					<el-input clearable v-model="formInline.phone" size="small" placeholder="请输入电话" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="顾客类型：">
					<el-select v-model="formInline.customerType" placeholder="请选择顾客类型" filterable size="small" @change="inputChange">
						<el-option v-for="item in customerTypeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="档案编号：">
					<el-input clearable v-model="formInline.customerNo" size="small" placeholder="请输入档案编号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
				</el-form-item>
				<el-form-item style="float: right; margin-right: 0"></el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe highlight @get-data="getListData" @current-change="handleCustomerCurrentChange">
				<template #gender>
					<el-table-column align="center" label="性别">
						<template #default="scope">
							<span v-if="scope.row.gender == 1" class="one_1">
								{{ formatterFre(scope.row.gender) }}
							</span>
							<span v-if="scope.row.gender == 0" class="one_2">
								{{ formatterFre(scope.row.gender) }}
							</span>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" class="title" @click="submitSelectCustomer">确认</el-button>
			</div>
		</template>
	</my-dialog>
</template>

<script>
import { getCustomerInfoPageList } from "@/api/baseDataApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
export default {
	data() {
		return {
			showDialog: false,
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			storeList: [],
			selectionKeyId: "",
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				name: "",
				phone: "",
				belongStoreKeyId: "",
				customerType: 0,
				customerNo: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "name",
					label: "顾客姓名",
					align: "center",
					isKeep: true,
					width: "120"
				},
				{
					prop: "customerTypeStr",
					label: "顾客类型",
					align: "center",
					width: "120"
				},
				{
					prop: "customerNo",
					label: "档案编号",
					align: "center",
					width: "140"
				},
				{
					prop: "phone",
					label: "联系电话",
					align: "center",
					width: "140"
				},
				{
					slot: "gender",
					label: "性别",
					width: "80"
				},
				{
					prop: "age",
					label: "年龄",
					align: "center",
					width: "80"
				},
				{
					prop: "belongStoreName",
					label: "所属门店",
					align: "center",
					minWidth: "140"
				},
				{
					prop: "creator",
					label: "创建人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "createTime",
					label: "创建时间",
					align: "center",
					minWidth: "150"
				},
				{
					prop: "editor",
					label: "维护人",
					align: "center",
					minWidth: "80"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					align: "center",
					minWidth: "150"
				}
			],
			customerTypeList: []
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetEnumConfigListByCode();
	},
	computed: {},
	methods: {
		//展示弹窗
		showSelectCustomerDialog(storeKeyId) {
			this.GetOrganizationListByConfig();
			this.showDialog = true;
			if (storeKeyId) {
				this.formInline.belongStoreKeyId = storeKeyId;
			}
			this.search();
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 获取顾客类型
		GetEnumConfigListByCode() {
			const paramer = {
				code: "CustomerType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.customerTypeList = [];
						res.data.forEach((item) => {
							this.customerTypeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
						this.customerTypeList.unshift({
							keyId: 0,
							value: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取顾客类型信息失败!");
				});
		},
		// 表格选中事件
		handleCustomerCurrentChange(currentRow) {
			if (currentRow == null || currentRow == undefined || currentRow == "") {
				return;
			}
			let keyId = currentRow.keyId;
			this.selectionKeyId = keyId;
		},
		// 性别
		formatterFre(gender) {
			return gender == 1 ? "男" : gender == 0 ? "女" : "";
		},
		changePages() {},
		// 获取所属门店
		GetOrganizationListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			getCustomerInfoPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		//选中后提交
		submitSelectCustomer() {
			if (this.selectionKeyId == "") {
				this.$message.error("请选择顾客");
				return;
			}
			this.$parent.chooseCustomer(this.selectionKeyId);
			this.closeDialog();
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
			this.selectionKeyId = "";
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.listData = [];
			this.storeList = [];
			this.selection = [];
		}
	}
};
</script>

<style scoped>
.one_1 {
	padding: 2px 20px;
	background: #e6f7ff;
	border: 1px solid #6acaf3;
	color: #56bbfd;
	border-radius: 2px;
}

.one_2 {
	padding: 2px 20px;
	background: #fcd4ff;
	border: 1px solid #dfbce2;
	color: #ea7cff;
	border-radius: 2px;
}
</style>
